import { FC } from 'react';
import { HoldingClass, Partner, TradingOffer } from 'types';
import { TradingOfferStatus } from 'types/TradingOffer';
import { formatCurrencyDecimals } from 'utils/formats';
import TradingOfferStatusBadge from './TradingOfferStatusBadge';

type EquityMarketAdminPanelOfferItemProps = {
  offer: TradingOffer;
  isSell: boolean;
  onViewDetail: (id: string) => void;
  getOfferStatus: (o: TradingOffer) => TradingOfferStatus;
  getPartnerName: (p: string | Partial<Partner>) => string;
  getShareClassName: (s: string | Partial<HoldingClass> | null) => string;
  t: (k: string) => string;
  formatCurrency: (n: number) => string;
  formatNumber: (n: number) => string;
};

const EquityMarketAdminPanelOfferItem: FC<
  EquityMarketAdminPanelOfferItemProps
> = ({
  offer,
  isSell,
  onViewDetail,
  getOfferStatus,
  getPartnerName,
  getShareClassName,
  t,
  formatCurrency,
  formatNumber,
}) => {
  const status = getOfferStatus(offer);
  const partnerName = getPartnerName(offer.partner);
  const shareClassName = getShareClassName(offer.shareClass);
  const totalAmount = offer.sharesCount.total * offer.sharePrice;
  const iconBg = isSell
    ? 'bg-success-dim text-success'
    : 'bg-info-dim text-info';
  const iconName = isSell ? 'ni-wallet-out' : 'ni-wallet-in';

  return (
    <div
      className="col-12 list-item-oferta doc-item d-flex align-items-center cursor-pointer"
      onClick={() => onViewDetail(offer._id)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && onViewDetail(offer._id)}
    >
      <div className={`doc-icon ${iconBg}`}>
        <em className={`icon ni ${iconName}`} />
      </div>
      <div className="flex-grow-1">
        <strong className="fs-13px">
          {formatNumber(offer.sharesCount.total)} {t('Shares').toLowerCase()} ·{' '}
          {shareClassName}
        </strong>
        <div className="text-soft fs-12px">
          {formatCurrencyDecimals(offer.sharePrice)}/{t('Share').toLowerCase()}{' '}
          · {t('Total')}: {formatCurrency(totalAmount)} ·{' '}
          {isSell ? t('Seller') : t('Buyer')}: {partnerName}
        </div>
      </div>
      <div className="d-flex align-items-center gap-2">
        <TradingOfferStatusBadge status={status} />
        <a
          className="btn btn-icon btn-round btn-trans"
          href="#"
          title={t('ViewDetail')}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onViewDetail(offer._id);
          }}
        >
          <em className="icon ni ni-forward-ios" />
        </a>
      </div>
    </div>
  );
};

export default EquityMarketAdminPanelOfferItem;
